<template>
  <div>
    <v-stepper v-model="step" class="rounded-0 claim-stepper" alt-labels flat>
      <!-- <v-stepper-header class="px-2 stepper-top accent">
        <v-stepper-step
          step="1"
          editable
          :complete="step > 1"
          class="px-0 step-header"
        >
          {{ $t("components.claims.batch_component.step1_title") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="2"
          :editable="memberIdentity !== null && memberIdentity !== undefined"
          :complete="step > 2"
          class="px-0 step-header"
        >
          {{ $t("globals.payments") }}
        </v-stepper-step>
      </v-stepper-header> -->

      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <pending-payment-claim-submissions
            :loading="loading"
            :claims="submittedClaims"
            :totalCount="totalCountSubmitted"
            @pagination="loadPendingPaymentClaimSubmissions($event)"
            @claims-selected="setSelected"
            @preview-proof="previewProof"
          />
          <v-alert
            v-for="(error, i) in errors"
            dense
            type="error"
            :key="i"
            dismissible
          >
            {{ $t(error) }}
          </v-alert>
          <v-card-actions>
            <v-btn @click="createBatch" color="primary" :disabled="selected.length===0" :loading="loading">
              {{ $t("components.claims.batch_component.create_batch") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-0">
          <pbas-data-table
            ref="table"
            :dataProvider="provider"
            @error="error = $event"
            :showSelect="false"
          ></pbas-data-table>
          <v-card-actions>
            <v-btn @click="exportBatchFileHandler" color="primary" :loading="loading">
              {{ $t("components.claims.batch_component.export_batch_file") }}
            </v-btn>
          </v-card-actions>
          <!-- <v-card-actions>
            <v-btn @click="step = 1" text>
              {{ $t("globals.back") }}
            </v-btn>
          </v-card-actions> -->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <file-preview-base64
      :fullScreen="false"
      v-if="preview"
      :view="preview"
      :fileItems="fileItems"
      @close="closePreview"
    />
    <error-handler :error="error"></error-handler>

    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";
import PendingPaymentClaimSubmissions from "@/components/Claims/PendingPaymentClaimSubmissions.vue";
import FilePreviewBase64 from "@/components/Claims/FilePreviewBase64.vue";
import getClaimsPaymentsHeaders from "../../headers/ClaimsPayments";
import { ODataProvider } from "pbas-vue-components";
import { saveAs } from "file-saver";

export default {
  components: {
    ErrorHandler,
    PendingPaymentClaimSubmissions,
    FilePreviewBase64,
  },
  props: ["paymentMethod", "plan"],
  data() {
    return {
      error: undefined,
      snackbar: false,
      successMessage: "",
      step: 1,
      memberIdentity: null,
      loading: false,
      submittedClaims: [],
      totalCountSubmitted: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
      },
      selected: [],
      preview: false,
      fileItems: null,
      batchId: null,
      provider: undefined,
      errors: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  mounted() {
    this.loadPendingPaymentClaimSubmissions();
  },
  methods: {
    ...mapActions("claims", [
      "getPendingPaymentClaimSubmissions",
      "newBatch",
      "exportBatchFile",
    ]),
    ...mapActions("plansMembers", ["getMemberInfo"]),
    ...mapActions("documentsService", ["getFile"]),
    async loadPendingPaymentClaimSubmissions(options) {
      if (this.plan === null || this.plan === undefined) {
        this.submittedClaims = [];
        this.totalCountSubmitted = 0;
        return;
      }
      if (options && options.itemsPerPage) {
        this.tableOptions = options;
      }
      // console.log(this.tableOptions);
      try {
        this.loading = true;
        const data = (await this.getPendingPaymentClaimSubmissions({
          planIdentityId: this.plan.Id,
          paymentMethod: this.paymentMethod,
          itemsPerPage: this.tableOptions.itemsPerPage
            ? this.tableOptions.itemsPerPage
            : 20,
          page: this.tableOptions.page,
          sortBy: this.computeSortBy(),
          sortDesc: this.computeSortDesc(),
        })).data;

        this.submittedClaims = data.value;
        this.totalCountSubmitted = data["@odata.count"];
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    computeSortBy() {
      if (this.tableOptions.sortBy && this.tableOptions.sortBy.length > 0) {
        return this.tableOptions.sortBy[0];
      }
      return "Timestamp";
    },
    computeSortDesc() {
      if (this.tableOptions.sortDesc && this.tableOptions.sortDesc.length > 0) {
        return this.tableOptions.sortDesc[0];
      }
      return null;
    },
    setSelected({ items }) {
      this.selected = items;
    },
    async previewProof(proof) {
      this.loading = true;
      // console.log("preview-proof", proof);
      proof.UploadName =
        "#" + (proof.ClaimLines[0] + 1) + "-" + proof.ProofType;

      const getFileBase64 = (fileSegment) => {
        // eslint-disable-next-line no-async-promise-executor, no-unused-vars
        return new Promise(async (resolve, reject) => {
          try {
            let file = (await this.getFile(fileSegment.PhysicalFileId)).data;
            if (file[0] === '"') file = file.slice(1, -1);
            fileSegment.Base64 = file;
            fileSegment.FileExtension = this.$helpers.fileExtension(
              fileSegment.FileName
            );
            resolve(fileSegment);
          } catch (error) {
            reject(error);
          }
        });
      };

      try {
        await Promise.all(proof.FileSegments.map((fs) => getFileBase64(fs)));
        this.fileItems = proof;
        this.preview = true;
      } catch (error) {
        // console.log(error);
      } finally {
        this.loading = false;
      }
    },

    closePreview() {
      this.preview = false;
      this.fileItem = null;
    },

    async createBatch() {
      try {
        this.loading = true;
        const data = (await this.newBatch({
          payload: {
            PaymentMethod: this.paymentMethod,
            ClaimSubmissionIds: this.selected.map((o) => o.Id),
          },
        })).data;
        this.batchId = data;
        this.step = 2;
        this.$nextTick(() => {
          this.loadPayments();
        });
      } catch (error) {
        // this.error = error;
        this.errors = [];
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 6000
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["6001"] !== null && errors["6001"] !== undefined) {
            for (const row of errors["6001"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_6001_{0}_{1}", [
                  row.Payee.toString(),
                  row.SubmissionSequence.toString(),
                ])
              );
            }
          }
          if (errors["6002"] !== null && errors["6002"] !== undefined) {
            for (const row of errors["6002"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_6002_{0}_{1}", [
                  row.Payee.toString(),
                  row.SubmissionSequence.toString(),
                ])
              );
            }
          }
        } else {
          this.error = error;
        }
      } finally {
        this.loading = false;
      }
    },

    loadPayments() {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        `${this.settings.APIURL}plans/${this.plan.Id}/claim-payments`,
        getClaimsPaymentsHeaders(this.options.Enums, false)
      );
      this.provider.filter = `BatchId eq ${this.batchId}`;
    },

    async exportBatchFileHandler() {
      try {
        this.loading = true;
        const data = (await this.exportBatchFile({
          planIdentityId: this.plan.Id,
          batchId: this.batchId,
        })).data;
        for (const f of data) {
          const fileId = f.Id;
          const fileName = f.Name;

          const file = (await this.getFile(fileId)).data;
          const blob = this.$files.b64toBlob(file);
          saveAs(blob, fileName);
        }
        this.$emit("close");
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-btn--outlined {
  border: thick solid;
}
.claim-btn {
  font-weight: 600 !important;
}
.claim >>> .v-btn__content {
  max-width: 180px;
  white-space: normal !important;
}
.preview-dialog >>> .v-dialog {
  margin: 0 24px !important;
}
.v-stepper__header {
  box-shadow: none;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 100px;
}
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px -35px 0;
}
.step-header >>> .v-stepper__label {
  display: block !important;
  text-align: center;
  color: white !important;
}
.step-header >>> .v-stepper__label {
  display: block !important;
  text-align: center;
  color: white !important;
  font-size: 16px;
}
.double-border >>> .v-btn__content {
  background-color: var(--accent);
  border-radius: 10px;
  padding: 1em 1em;
  position: relative;
  margin: 0 auto;
  width: 160px;
  white-space: break-spaces;
}
.double-border >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--disabled >>> .v-btn__content {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1em;
  position: relative;
  margin: 0 auto;
}
.double-border.v-btn--disabled >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
@media screen and (max-width: 460px) {
  .step-header >>> .v-stepper__label {
    font-size: 12px;
  }
}
.step-header >>> .v-stepper__step__step.primary {
  background-color: white !important;
  color: var(--accent);
  font-weight: 600;
}
.step-header >>> .v-stepper__step__step.primary i {
  color: var(--accent);
  font-weight: 600;
}
.claim-stepper >>> hr {
  border-top: 1px solid white !important;
  margin: 23px -30px 0 !important;
}
.step-header {
  padding: 12px 12px;
}
@media screen and (min-width: 1500px) {
  .stepper-top {
    padding: 0px 300px !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1499px) {
  .stepper-top {
    padding: 0px 200px !important;
  }
}
@media screen and (max-width: 999px) {
  .stepper-top {
    padding: 0px 20px !important;
  }
}
.double-border >>> .v-btn__content {
  background-color: var(--accent);
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--disabled >>> .v-btn__content {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border.v-btn--disabled >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--loading {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border >>> .v-btn__loader {
  color: var(--accent);
}
.apply-text {
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
}
.v-tooltip__content {
  max-width: 120px !important;
}
.apply-text {
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
}
</style>
